import { buildConnectorParametersDecryptUrl } from '../../utils/connectorParametersApi';

// Get token from localStorage
const token = localStorage.getItem('token');

// Force refresh to clear any cached references
console.log('UNANET Connector loaded successfully');

export const getUnanetCredentialsAndCreateToken = async (connectorId, mcId, masterConnectors) => {
  console.log('🔍 Frontend: getUnanetCredentialsAndCreateToken() called:');
  console.log('   - Connector ID:', connectorId);
  console.log('   - Master Connector ID:', mcId);
  console.log('   - Master Connectors count:', masterConnectors?.length);
  console.log('   - Current time:', new Date().toISOString());

  try {
    // Find the UNANET master connector details
    const unanetConnector = masterConnectors.find(mc =>
      (mc.mcRecId?.toString() === mcId?.toString() ||
       mc.mcId?.toString() === mcId?.toString()) &&
      mc.mcName === "Unanet"
    );
    
    console.log('   - UNANET connector found:', !!unanetConnector);
    if (unanetConnector) {
      console.log('   - Connector details:', {
        mcId: unanetConnector.mcId,
        mcName: unanetConnector.mcName,
        mcRecId: unanetConnector.mcRecId
      });
    }

    if (!unanetConnector) {
      console.error('   ❌ UNANET master connector not found');
      throw new Error('UNANET master connector not found');
    }

    console.log('   - Fetching connector parameters from API...');
    // Fetch connector parameters from the API endpoint using connector instance ID (ctd_id)
    const paramResponse = await fetch(buildConnectorParametersDecryptUrl(connectorId), {
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      }
    });

    if (!paramResponse.ok) {
      throw new Error('Failed to fetch connector parameters');
    }

    const connectorParams = await paramResponse.json();
    console.log('   - Connector parameters fetched successfully');

    const paramBaseUrl = connectorParams.find(param => param.scpName === "baseurl")?.scpValue;
    const baseUrl = paramBaseUrl || 'https://thayermahan-sand.sandbox.unanetim-gc.biz';

    console.log('   - Base URL:', baseUrl);

    console.log('   - Making API request to backend authorize endpoint...');

    // Call the UNANET authorization endpoint using connector instance ID (ctd_id)
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}synctrack/unanet/authorize?mcId=${connectorId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      }
    });

    console.log('   - API response status:', response.status);

    if (!response.ok) {
      const errorData = await response.json();
      console.error('   ❌ API request failed:', errorData);
      throw new Error(errorData.message || 'Failed to authenticate with UNANET');
    }

    const tokenResponse = await response.json();
    console.log('   ✅ UNANET authentication successful');
    console.log('   - Access Token:', tokenResponse.access_token ? `${tokenResponse.access_token.substring(0, 20)}...` : 'Not provided');
    console.log('   - Token Type:', tokenResponse.token_type);
    console.log('   - Warehouse ID:', tokenResponse.warehouse_id);
    console.log('   - Role ID:', tokenResponse.role_id);

    return tokenResponse;

  } catch (error) {
    console.error('   ❌ Error in UNANET authentication:', error);
    throw error;
  }
};

export const testUnanetConnection = async (connectorId) => {
  console.log('🔍 Frontend: testUnanetConnection() called for connectorId (ctd_id):', connectorId);

  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}synctrack/unanet/test-connection?mcId=${connectorId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      }
    });

    console.log('   - Test connection response status:', response.status);

    if (!response.ok) {
      const errorData = await response.json();
      console.error('   ❌ Test connection failed:', errorData);
      throw new Error(errorData.message || 'Failed to test UNANET connection');
    }

    const result = await response.json();
    console.log('   ✅ UNANET test connection successful');
    console.log('   - Result:', result);

    return result;

  } catch (error) {
    console.error('   ❌ Error testing UNANET connection:', error);
    throw error;
  }
};
